export function fmtPct(v, digits = 0) {
  if (v == null || Number.isNaN(Number(v))) return '—';
  return `${Number(v).toFixed(digits)}%`;
}

export function fmtInt(v) {
  if (v == null || v === '') return '—';
  const n = Number(v);
  return Number.isNaN(n) ? String(v) : n.toLocaleString();
}

export function fmtIndex(v) {
  if (v == null) return 'n/a';
  return String(Math.round(v));
}

export function fmtRatio(index) {
  if (index == null) return '';
  if (index >= 100) return `${(index / 100).toFixed(1)}×`;
  return `${Math.round(100 - index)}% less`;
}

/** Tailwind classes for an index badge: ≥150 green, ≤67 red, else neutral. */
export function indexTone(index, significant) {
  if (index == null) return 'bg-gray-100 text-gray-500';
  const muted = significant === false;
  if (index >= 150) return muted ? 'bg-green-50 text-green-700/60' : 'bg-green-100 text-green-800';
  if (index <= 67) return muted ? 'bg-red-50 text-red-700/60' : 'bg-red-100 text-red-800';
  return muted ? 'bg-gray-50 text-gray-500' : 'bg-gray-100 text-gray-700';
}

export function fmtDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
